import { render, staticRenderFns } from "./SpecimenFull.vue?vue&type=template&id=fbb65782&scoped=true&"
import script from "./SpecimenFull.vue?vue&type=script&lang=js&"
export * from "./SpecimenFull.vue?vue&type=script&lang=js&"
import style0 from "./SpecimenFull.vue?vue&type=style&index=0&id=fbb65782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb65782",
  null
  
)

export default component.exports